import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  // Constrain OpenUI-rendered content to the bubble width; let wide charts and
  // tables scroll horizontally rather than overflow the chat panel.
  root: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto',
  },
}))
